namespace TabAurous.HR {
    export interface EmployeeAdvanceRow {
        TransId?: number;
        EmployeeId?: number;
        LedgerId?: number;
        VoucherNo?: string;
        InvoiceNo?: string;
        Date?: string;
        Amount?: number;
        SalaryMonth?: string;
        Chequenumber?: string;
        ChequeDate?: string;
        Narration?: string;
        ExtraDate?: string;
        Extra1?: string;
        Extra2?: string;
        SuffixPrefixId?: number;
        VoucherTypeId?: number;
        FinancialYearId?: number;
        CompanyId?: number;
    }

    export namespace EmployeeAdvanceRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'HR.EmployeeAdvance';
        export const deletePermission = 'HR:EmployeeAdvance:Delete';
        export const insertPermission = 'HR:EmployeeAdvance:Add';
        export const readPermission = '*';
        export const updatePermission = 'HR:EmployeeAdvance:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            EmployeeId = "EmployeeId",
            LedgerId = "LedgerId",
            VoucherNo = "VoucherNo",
            InvoiceNo = "InvoiceNo",
            Date = "Date",
            Amount = "Amount",
            SalaryMonth = "SalaryMonth",
            Chequenumber = "Chequenumber",
            ChequeDate = "ChequeDate",
            Narration = "Narration",
            ExtraDate = "ExtraDate",
            Extra1 = "Extra1",
            Extra2 = "Extra2",
            SuffixPrefixId = "SuffixPrefixId",
            VoucherTypeId = "VoucherTypeId",
            FinancialYearId = "FinancialYearId",
            CompanyId = "CompanyId"
        }
    }
}
